var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _path23, _path24, _path25, _path26, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 51",
    style: {
      enableBackground: "new 0 0 85 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#828383;}\n\t.st2{opacity:0.79;}\n\t.st3{fill:#010B40;}\n\t.st4{opacity:0.62;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{opacity:0.76;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:url(#SVGID_00000148622798016622027490000018398637171648325788_);}\n\t.st8{fill:url(#SVGID_00000088126594013395374630000015281418886756247424_);}\n\t.st9{fill:url(#SVGID_00000068672126543875634160000008528932235619116674_);}\n\t.st10{fill:url(#SVGID_00000123427599635637845930000000021025735250671246_);}\n\t.st11{fill:#606060;}\n\t.st12{fill:url(#SVGID_00000070105604569184109280000011390512512253953460_);}\n\t.st13{fill:url(#SVGID_00000093144283058863235810000018361525097142224562_);}\n\t.st14{fill:url(#SVGID_00000122698102018422371620000006164848239612558778_);}\n\t.st15{fill:url(#SVGID_00000070100845583214870030000012778362012184147638_);}\n\t.st16{fill:url(#SVGID_00000175317553248720351560000016408674547085453230_);}\n\t.st17{fill:url(#SVGID_00000072962895563658259230000002255693381196332172_);}\n\t.st18{fill:url(#SVGID_00000139274608907309595570000011313265849286652329_);}\n\t.st19{display:none;}\n\t.st20{display:inline;fill:#EE9956;}\n\t.st21{display:inline;fill:#F4BA8E;}\n\t.st22{display:inline;fill:#DB0081;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1095,
    y1: 11.6323,
    x2: 40.1095,
    y2: 48.7086,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,36h-6.7c0.2-0.3,0.2-0.6,0.2-1V5.4c0-0.6-0.2-1.1-0.7-1.5c-0.4-0.4-1-0.6-1.6-0.6H14.3 c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.4,0.4-0.5,0.7c-0.1,0.3-0.2,0.5-0.2,0.8V35c0,0.3,0.1,0.7,0.2,1H5.4 c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4V37c0,0.9,0.4,1.7,1,2.3c0.6,0.6,1.5,0.9,2.3,0.9h64c0.9,0,1.7-0.3,2.3-0.9 c0.6-0.6,1-1.4,1-2.3v-0.5c0-0.2-0.1-0.3-0.2-0.4C75.1,36.1,75,36,74.8,36z M33.6,37.8L33,37.2h14.2l-0.6,0.6L33.6,37.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74,43.9c-0.8,0.8-1.6,1.4-2.2,1.9c-7.2,5.1-15.8,3.7-17.7,3.3c-2.7-0.5-7.9-1.6-11.7-6 C36.7,36.5,37.6,26,42,19.2c0.8-1.3,5.1-8.3,13.8-9.4c5.3-0.7,11.4,0.7,15.8,4.3C80.9,21.9,80.2,37.5,74,43.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,28.6c0,0,0.9-16.7,10.2-26.7c0.1-0.1,0.3-0.1,0.4,0.1C73.8,4.6,80.1,21.2,62.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72,6.7c0,0.5-0.1,1-0.2,1.4c-0.1,0.5-0.2,1-0.3,1.4c-0.2,1-0.4,1.9-0.7,2.9c-0.1,0.2-0.1,0.5-0.2,0.7 c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.2-0.1,0.5-0.2,0.7L70.1,15L70,15.3c-0.3,0.9-0.7,1.8-1,2.7c-0.4,0.9-0.8,1.8-1.3,2.6 c-0.1,0.1-0.1,0.2-0.2,0.3l-0.1,0.3l-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3l-0.4,0.6l-0.1,0.1l-0.1,0.2l-0.2,0.3 c-1.1,1.7-2.3,3.2-3.6,4.6l0,0l0,0l0,0l0.5-0.6l0.3-0.3l0.2-0.3l0.5-0.6l0.4-0.6c0.1-0.1,0.2-0.2,0.2-0.3l0.2-0.3 c0.1-0.2,0.3-0.4,0.4-0.6c0.3-0.4,0.5-0.8,0.8-1.2l0.2-0.3l0.1-0.1l0.1-0.1l0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.3l0.2-0.3l0.2-0.3 c0.1-0.1,0.1-0.2,0.1-0.3c0.5-0.9,0.8-1.7,1.2-2.6s0.7-1.8,1-2.7l0.1-0.4l0.1-0.4c0.1-0.2,0.1-0.5,0.2-0.7 c0.1-0.5,0.3-0.9,0.4-1.4c0.3-0.9,0.5-1.9,0.7-2.8c0.1-0.5,0.2-1,0.3-1.4c0.1-0.2,0.1-0.5,0.1-0.7C71.9,7.2,71.9,7,72,6.7L72,6.7 C71.9,6.7,71.9,6.7,72,6.7C72,6.7,72,6.7,72,6.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.7,38.2c0,0-17.7,0.1-28.7,9.4c-0.2,0.1-0.1,0.3,0.1,0.4C26.6,49.3,43.9,56.7,52.7,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29,47.3c1-0.1,2.1-0.2,3.1-0.4c1-0.2,2-0.4,3-0.6c0.5-0.1,1-0.2,1.5-0.4c0.3-0.1,0.5-0.2,0.7-0.2l0.4-0.1 l0.4-0.1c1-0.3,2-0.6,2.9-1c1-0.3,1.9-0.7,2.8-1.2c0.1,0,0.2-0.1,0.4-0.1l0.3-0.2l0.3-0.2c0.1,0,0.2-0.1,0.3-0.2l0.7-0.4l0.2-0.1 l0.2-0.1l0.3-0.2c0.5-0.2,0.9-0.5,1.4-0.8c0.2-0.1,0.4-0.3,0.7-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.7-0.5l0.6-0.5l0.3-0.2 l0.3-0.2l0.6-0.5l0,0l0,0l0,0c-1.6,1.3-3.2,2.6-5,3.6l-0.3,0.2l-0.2,0.1l-0.2,0.1l-0.7,0.4c-0.1,0-0.2,0.1-0.3,0.2l-0.3,0.2 l-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.9,0.4-1.9,0.8-2.8,1.2c-1,0.3-1.9,0.7-2.9,1l-0.4,0.1l-0.4,0.1c-0.3,0.1-0.5,0.2-0.7,0.2 c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.5,0.1-0.8,0.2c-2,0.4-4.1,0.8-6.1,0.9C29,47.4,29,47.4,29,47.3C29,47.3,29,47.3,29,47.3 L29,47.3z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.3,3.6H15.1c-1.3,0-2.4,1.1-2.4,2.4v28.5c0,1.3,1.1,2.4,2.4,2.4h50.2c1.3,0,2.4-1.1,2.4-2.4V6 C67.7,4.7,66.7,3.6,65.3,3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.5,8.4H13.9v27.2h52.6V8.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.2,6.5c0.3,0,0.5-0.2,0.5-0.5c0-0.2-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5C39.7,6.3,39.9,6.5,40.2,6.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.3,35.7l-1.8,1.8H33.7l-1.6-1.8H6.2c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4v0.5 c0,0.8,0.3,1.6,0.9,2.2c0.6,0.6,1.4,0.9,2.3,0.9h62.6c0.9,0,1.7-0.3,2.3-0.9c0.6-0.6,0.9-1.4,0.9-2.2v-0.5c0-0.1-0.1-0.3-0.2-0.4 c-0.1-0.1-0.3-0.2-0.4-0.2H48.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161606704404756748460000011528122200853756343_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.1548,
    y1: -21478.3086,
    x2: 19.1548,
    y2: -10170.3105,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161606704404756748460000011528122200853756343_)"
    },
    d: "M30.2,9.4H8.1C7.5,9.4,7,9.6,6.6,10 C6.2,10.4,6,10.9,6,11.4v29.9c0,0.5,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.6h22.2c0.5,0,1.1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.4 V11.4c0-0.5-0.2-1-0.6-1.4C31.3,9.6,30.8,9.4,30.2,9.4z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,9.8H8.4c-1.2,0-2.1,0.9-2.1,2v29.1c0,1.1,0.9,2,2.1,2h21.5c1.2,0,2.1-0.9,2.1-2V11.8 C32,10.7,31,9.8,29.9,9.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.7,12.9h-23v26.9h23V12.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.1,11.6c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3C18.7,11.5,18.9,11.6,19.1,11.6 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.1,42.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9C18.1,41.8,18.5,42.2,19.1,42.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066482927434547834670000012689951624726086572_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.641,
    y1: -17501.3086,
    x2: 7.641,
    y2: -10595.21,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066482927434547834670000012689951624726086572_)"
    },
    d: "M13.3,19.5H1.9c-0.1,0-0.3,0-0.4,0.1 s-0.3,0.1-0.4,0.2C1,20,1,20.1,0.9,20.2c-0.1,0.1-0.1,0.3-0.1,0.4v24.3c0,0.1,0,0.3,0.1,0.4C1,45.5,1,45.6,1.1,45.7 c0.1,0.1,0.2,0.2,0.4,0.2C1.7,46,1.8,46,1.9,46h11.4c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4 c0.1-0.1,0.1-0.3,0.1-0.4V20.6c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.3-0.2-0.4s-0.2-0.2-0.4-0.2C13.6,19.6,13.5,19.5,13.3,19.5 L13.3,19.5z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.2,19.7H2.1c-0.6,0-1.1,0.5-1.1,1.1v23.9c0,0.6,0.5,1.1,1.1,1.1h11.1c0.6,0,1.1-0.5,1.1-1.1V20.9 C14.4,20.2,13.8,19.7,13.2,19.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.4,22.2H1.9v21.3h11.5V22.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M6.3,21.1c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1s-0.1,0-0.1,0.1C6.2,21,6.2,21.1,6.3,21.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9,20.9H6.9c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.1H9c0.1,0,0.1,0,0.1-0.1C9.1,20.9,9.1,20.9,9,20.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M7.6,45.2c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7C6.9,44.9,7.2,45.2,7.6,45.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "47.1,36.9 46.5,37.5 33.7,37.5 33.2,36.9 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021101853417309399070000000706320451429067963_",
    gradientUnits: "userSpaceOnUse",
    x1: -7626.7622,
    y1: 3.0561,
    x2: -7617.1875,
    y2: 27.7051,
    gradientTransform: "matrix(-1 0 0 -1 -7544.3174 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021101853417309399070000000706320451429067963_)"
    },
    d: "M74.8,26.4l3.4,0.8l-0.8,6.4 c0,0,1.3,1.3,1.7,3c0.4,1.7,0.8,8.8,0.8,8.8l0.8,0.5l0.1,0.4l-2.4,3.1l0.4-2.5c0-0.4,0-1.2,0-1.2c-1.3-3.4-4-13-4-13V26.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012451122400165710000000887201059977789319_",
    gradientUnits: "userSpaceOnUse",
    x1: -7626.897,
    y1: -76.2388,
    x2: -7595.2505,
    y2: 293.6255,
    gradientTransform: "matrix(-1 0 0 -1 -7544.3174 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091012451122400165710000000887201059977789319_)"
    },
    d: "M73.8,46.3 C73.9,46.3,73.9,46.3,73.8,46.3c-0.1-2-0.8-11-1.6-14.4c-0.8-3.8,1.3-11.4,1.3-11.4l3.8,3.8l-2.1,7.2c1.4,2.2-0.2,14.9-0.2,14.9v0 l0.6,0.7l0,0.4l-3.4,2l1.3-2.2C73.7,47.1,73.8,46.7,73.8,46.3z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.9,49.9H73c0.2,0,0.4-0.1,0.5-0.2c0.3-0.4,1-1.3,1.4-1.3c0.5,0,0.4,1.6,0.4,1.6h0.2l0.3-2 c0.1-0.5-0.2-1-0.6-1.2l0,0c0,0-0.1,0.7-0.6,1.1c-0.6,0.3-2.3,1.5-2.3,1.5s-0.2,0-0.4,0C71.5,49.4,71.6,49.9,71.9,49.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.3,49.8l1-0.4c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.6,0.5-1.6,0.7-1.8c0.4-0.2,1,1.3,1,1.3l0.2-0.1l-0.5-1.9 c-0.1-0.5-0.6-0.8-1.1-0.9l0,0c0,0,0.2,0.7-0.2,1.2s-1.5,2.3-1.5,2.3s-0.2,0-0.4,0.2C77.8,49.4,78.1,49.9,78.3,49.8z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,8.2c2.3,0.5,3.5,2.8,2.4,5.6c-1.2,3.2-0.1,9.6-0.1,9.6s-2.1,0.7-3.4,0.6c-1.3-0.1-2.8-1-2.8-1 s-0.5-6.7-1.4-8.9C70.4,11.9,71.5,7,76.5,8.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.2,19.2c1.4,0.7,4.7,0.4,6.3-0.3c1.3,3.9,2.2,10.3,1.9,12.2c-0.3,1.9-0.4,2.9-0.7,3.1 c-0.1,0-0.3,0.1-0.8,0.1c-0.2,0,0-2.2-0.3-2.2c-0.1,0-0.7,2.2-0.8,2.2c-1.4,0-3.2-0.1-3.2-0.1s-5-0.9-5.2-1.1 c-0.3-0.2,1.5-4.4,2.3-6C72.6,25.2,72.2,19.2,72.2,19.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.3,8.4c-2.3,1-3.6,4.2-3.6,5.5c0,1.3,0,0.9,0,0.9l2.4-0.4L73.3,8.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,8c2.7,0,4.2,1.5,4.8,4.1c0.3,1.5,0.6,2.3,0.6,2.3h-3.1L75.2,8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M75.5,7.8c0.4,0,0.5,0.6,0.6,1c0.1,0.4-0.8,2.3-0.9,2.3c-0.2,0-0.9-1-0.9-1l-0.9,1.1c0,0-0.4-2.4-0.3-2.7 C73.1,8.3,73.5,7.6,75.5,7.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182497971216020935530000015187020519551417755_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.5787,
    y1: 7.6006,
    x2: 73.5016,
    y2: 7.6006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182497971216020935530000015187020519551417755_)"
    },
    d: "M74.2,9.7c1,0.3,1.1-0.3,1.3-0.8 c0.2-0.5-0.3-3.3-0.6-3.5c-0.3-0.2-1.1,0.2-1.2,0.5C73.6,6.2,73.1,9.4,74.2,9.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100346236229942570720000014586680032554962098_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.8763,
    y1: 17.4698,
    x2: 71.6696,
    y2: 17.4698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100346236229942570720000014586680032554962098_)"
    },
    d: "M69.9,15.2c-0.1,1.1,0.1,4.2,0.4,4.4 c0.3,0.3,1.4-4.1,1.4-4.1L69.9,15.2z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M74.5,19.4c0-0.3,0-0.7,0-1.1c0-0.7,0-1.4-0.1-1.9l-0.1-0.3c-0.3-1.1-0.4-1.6-0.6-2.9c-0.1-0.6,0-1.6,0.1-2 c0-0.2,0-0.3,0-0.5c0-0.4,0-0.6,0.4-1l0.1,0.1C74,10.2,74,10.4,74,10.7c0,0.1,0,0.3,0,0.5c0,0.4-0.1,1.4-0.1,2 c0.1,1.3,0.3,1.8,0.6,2.9l0.1,0.3c0.1,0.5,0.1,1.2,0.1,1.9c0,0.4,0,0.8,0,1.1L74.5,19.4z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.4,14.5l0.3,1c0,0-1.9,0.4-1.9,0.4c0,0-0.1-1,0-1.1S71.4,14.5,71.4,14.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140727156749827141990000007757435501561399990_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.1865,
    y1: 14.4167,
    x2: 74.5695,
    y2: 14.4167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140727156749827141990000007757435501561399990_)"
    },
    d: "M70.8,15.6c0.3-1.9,2.1-4,1.8-4.8 c0-0.1-0.1-0.3,0-0.4c-0.2-0.4-0.2-0.7-0.2-1.1c0-0.1,0.1-0.2,0.2-0.1c0.2,0.1,0.2,0.3,0.3,0.5c0.4-0.7,1-1.3,1.4-1 c0.6,0.4,0.3,1.8-0.2,2.1c-0.4,0.4-0.6,1.1-0.6,2.8c0,1.2-1.1,6.8-2.6,6.8C69.5,20.3,70.6,16.6,70.8,15.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043445976428246772590000003445991108287599027_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.2411,
    y1: 17.9267,
    x2: 80.7759,
    y2: 17.9267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043445976428246772590000003445991108287599027_)"
    },
    d: "M80.5,15.3c0.1,0.5,0.7,4.4,0,5 c-0.7,0.6-7.9,0.1-8.8,0.1c-2-0.1-2.5-1.2-2.3-1.4c0.2-0.2,0.5,0.4,1.1,0.4c0.4,0,0.9,0.1,1.1,0.1c0.5,0-0.9-0.5-0.8-0.7 c0-0.2,1.1,0,1.4,0.3c0.6,0.5,5.9-0.2,6.2-0.5s0-3.5,0-3.5L80.5,15.3z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.3,4.1c-0.8-1.8,1.3-4,3.5-3.2C77.5,1.4,78,2.9,78,2.9s1.2-1.4,2.7-0.8c2.5,1.1,0.3,4.4-0.6,5.2 c-0.9,0.7-0.3,2.8-0.3,2.8s-1.7-0.3-1.9-1.9c-0.3-1.5,1.3-3.4,1.3-4c0-0.9-1.3-0.7-1.3-0.7s0.1,1.6-0.3,2.2c-0.4,0.7-1.9,1-1.9,1 L72.3,4.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78,14.7c0-0.1,0.2-0.2,0.3-0.2c0.6,0,1.9,0,2.2,0c0.4,0,0.3,0.9,0.2,1c0,0.1-1.7,0.1-2.5,0.1 c-0.2,0-0.4-0.2-0.4-0.5L78,14.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054964467961678140400000005401395973897727676_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.1339,
    y1: 4.5519,
    x2: 77.1077,
    y2: 4.5519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054964467961678140400000005401395973897727676_)"
    },
    d: "M73.5,7.6c-0.9-0.2-1.7-1.5-1.3-3.4 c0.4-1.9,1.4-3.1,2.9-2.6c1.6,0.5,2,1.3,1.9,2.9C77,6,74.7,7.9,73.5,7.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013173411167127767970000016253636575781954451_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.6525,
    y1: 4.8463,
    x2: 77.6189,
    y2: 4.8463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013173411167127767970000016253636575781954451_)"
    },
    d: "M77,4.3c0.6,0,0.7,0.1,0.5,0.7 c-0.2,0.6-0.9,0.5-0.9,0.5L77,4.3z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,1.3c-0.3,0.8,0.6,2.2,1.1,2.7c0.6,0.5,1.3,0.1,1.3,0.1l0.3-0.8l-0.8-1.5L75.3,1L74.7,1.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,1.3c0,0-0.3,0.8-0.8,1.3c-0.5,0.4-1.4,0.6-1.4,0.6s0.6-1.6,1.2-1.8C74.4,1.1,74.7,1.3,74.7,1.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012463392830841705280000006002366757006652327_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.4053,
    y1: 5.3098,
    x2: 73.3074,
    y2: 5.3098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012463392830841705280000006002366757006652327_)"
    },
    d: "M73.2,4.3c0.1,0.1,0.1,1.9,0,2 c-0.2,0.1-0.7,0-0.8-0.1C72.3,6.1,73.1,4.1,73.2,4.3z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M73.4,23.3c-1.7,0.6-3,12.4-2.9,13c0.1,1,7.3,10.5,7.3,10.5l1.1-1.4l-4.2-9.1c0,0,3.4-8.7,3.6-10.1 C78.5,24.8,78.4,21.6,73.4,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M78.5,22.7c2.1,1.2,1.1,6.4,0.4,8.5c-0.7,2.1-2.1,3.7-1.7,4.6c0.4,0.9,1.2,3.8,0.8,5.3 c-0.4,1.5-1.7,6.5-1.7,6.5h-1.5c0,0-0.6-9.4-0.9-10.6c-0.2-1.2-0.9-10.3,0-12.8C74.3,23.2,76.8,21.7,78.5,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M76.4,47.1c0,0-0.3,0.2-0.8,0.2c-0.4,0-0.9-0.2-0.9-0.2s0,1.4-0.6,1.7c-0.6,0.3-1.8,0.6-1.9,0.8 c-0.1,0.2,0,0.5,0,0.5s3.4,0.2,3.9,0C76.6,49.9,76.4,47.1,76.4,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M78.7,44.9c0.4,0.3,1.5,1.5,1.4,1.9c-0.1,0.5-2.4,2.9-2.6,2.8c-0.1,0-0.2-0.2-0.3-0.3 c-0.1-0.2-0.1-0.4,0.1-0.5c0.3-0.4,0.8-1,0.8-1.2c0-0.3-0.6-1.2-0.6-1.2s0.3-0.2,0.7-0.5C78.6,45.6,78.7,44.9,78.7,44.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.667e482063a2eba796c5564860dd93ff.svg";
export { ForwardRef as ReactComponent };